export const getFacilityColor = (type: string | undefined) => {
  switch (type) {
    case '자연유하':
      return 'bg-cyan-100 text-cyan-800';
    case '양수저장':
      return 'bg-purple-100 text-purple-800';
    case '압력펌프':
      return 'bg-orange-100 text-orange-800';
    case '기타':
      return 'bg-gray-100 text-gray-800';
    default:
      return 'bg-gray-100 text-gray-800';
  }
};
